import { sortBy } from 'lodash-es'
import classes from './Sub.module.scss'
import dynamic from 'next/dynamic'

const CompletedOrdersBar = dynamic(() => import('./CompletedOrdersBar'))
const UpcomingOrdersBar = dynamic(() => import('./UpcomingOrdersBar'))
const SubProductDetail = dynamic(() => import('./SubProductDetail'))

import Accordion from '@mui/material/Accordion'
const ExpandMoreIcon = dynamic(() => import('@mui/icons-material/ExpandMore'))
const AccordionSummary = dynamic(() => import('@mui/material/AccordionSummary'))
const AccordionDetails = dynamic(() => import('@mui/material/AccordionDetails'))

export default function Sub({ defaultOpen, subscription, accountSettings }) {
  // Sort the open orders by date, past -> present -> future
  subscription.subscription_open_orders = sortBy(
    subscription.subscription_open_orders,
    [
      function (o) {
        return new Date(o?.delivery_date?.value)
      },
    ],
  )
  // Get the next upcoming delivery date
  const upNextDeliveryDate = subscription.subscription_open_orders.find(
    (o) => new Date() <= new Date(o?.delivery_date?.value),
  )

  // subscription.subscription_open_orders = subscription.subscription_open_orders.
  let estimatedDeliveryDate
  if (upNextDeliveryDate?.delivery_date?.value) {
    const date = new Date(upNextDeliveryDate.delivery_date.value)
    estimatedDeliveryDate = date.toLocaleDateString(undefined, {
      month: 'short',
      day: 'numeric',
    })
  }

  let title = subscription.subscription_lineitems[0]?.product
  if (!title || subscription.subscription_lineitems.length > 1) {
    title = 'Subscription'
    if (subscription.subscription_lineitems.length > 1) {
      title = title + ` (${subscription.subscription_lineitems.length} Items)`
    }
  }
  const isGiftSubscription = subscription.is_gift_subscription === true;
  return (
    <Accordion defaultExpanded={defaultOpen}>
      <AccordionSummary
        sx={{
          background: '#163144',
          color: 'white',
          borderRadius: '5px',
        }}
        expandIcon={<ExpandMoreIcon sx={{ color: 'white' }} />}
        id="sub-panel-header"
      >
        <div className={classes['panel-content']}>
          <h1>{isGiftSubscription ? 'Gift '+ title : title}</h1>
          {estimatedDeliveryDate && (
            <h1 className={classes['sub-header']}>
              Next Estimated Delivery{' '}
              <span className={classes['current-fulfill-date']}>
                {estimatedDeliveryDate}
              </span>
            </h1>
          )}
        </div>
      </AccordionSummary>
      <AccordionDetails>
        <CompletedOrdersBar subscription={subscription} />
        <UpcomingOrdersBar
          subscription={subscription}
          accountSettings={accountSettings}
        />
        {subscription.subscription_lineitems.length < 1 && (
          <h4 className={classes['no-upcoming']}>No upcoming deliveries</h4>
        )}
        {subscription.subscription_lineitems.length > 0 && (
          <SubProductDetail subscription={subscription} />
        )}
      </AccordionDetails>
    </Accordion>
  )
}
